import { render } from "./nick.vue?vue&type=template&id=1bd5b554&ts=true"
import script from "./nick.vue?vue&type=script&lang=ts"
export * from "./nick.vue?vue&type=script&lang=ts"

import exportComponent from "/home/webchat/thelounge-lfnet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__